/**
 * 内容处理工具
 * 用于处理HTML内容中的图片路径等
 */

// 从统一配置文件导入
import { getApiBaseUrl } from '../config/apiConfig';

/**
 * 处理HTML内容中的附件路径，将 /attachments/... 转换为完整URL
 * @param htmlContent HTML内容
 * @returns 处理后的HTML内容
 */
export const processAttachmentUrls = (htmlContent: string): string => {
  if (!htmlContent) return htmlContent;
  
  const baseUrl = getApiBaseUrl();
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  // 匹配所有 img 标签的 src 属性中的 /attachments/... 路径
  // 注意：不处理Base64图片（data:image/...）和blob URL（blob:...），保持原样
  htmlContent = htmlContent.replace(
    /(<img[^>]+src=["'])(\/attachments\/[^"']+)(["'][^>]*>)/gi,
    (match, prefix, path, suffix) => {
      // 确保路径以 / 开头
      const cleanPath = path.startsWith('/') ? path : `/${path}`;
      return `${prefix}${cleanBaseUrl}${cleanPath}${suffix}`;
    }
  );
  
  // 匹配所有 video 标签的 src 属性中的 /attachments/... 路径
  htmlContent = htmlContent.replace(
    /(<video[^>]+src=["'])(\/attachments\/[^"']+)(["'][^>]*>)/gi,
    (match, prefix, path, suffix) => {
      return `${prefix}${cleanBaseUrl}${path}${suffix}`;
    }
  );
  
  // 匹配所有 source 标签的 src 属性中的 /attachments/... 路径
  htmlContent = htmlContent.replace(
    /(<source[^>]+src=["'])(\/attachments\/[^"']+)(["'][^>]*>)/gi,
    (match, prefix, path, suffix) => {
      return `${prefix}${cleanBaseUrl}${path}${suffix}`;
    }
  );
  
  // 匹配所有 a 标签的 href 属性中的 /attachments/... 路径（附件下载链接）
  htmlContent = htmlContent.replace(
    /(<a[^>]+href=["'])(\/attachments\/[^"']+)(["'][^>]*>)/gi,
    (match, prefix, path, suffix) => {
      return `${prefix}${cleanBaseUrl}${path}${suffix}`;
    }
  );
  
  return htmlContent;
};

